import { RouteComponentProps, withRouter } from 'react-router-dom';
import ObjednavkaStore from 'src/stores/ObjednavkaStore';
import * as React from 'react'
import { inject, observer } from 'mobx-react';
import { Drawer, Grid, AppBar, Toolbar, IconButton, Typography, Paper, Table, TableHead, TableRow, TableCell, TableBody, Fab, Dialog, DialogTitle, DialogContent, DialogContentText, TextField, DialogActions, Button, Tooltip, createStyles, withStyles, WithStyles, Checkbox } from '@material-ui/core';
import NavigationDrawerItems from './NavigationDrawerItems';
import { observable, action, computed } from 'mobx';
import MenuIcon from '@material-ui/icons/Menu';
import AddIcon from '@material-ui/icons/Add';
import Objednavka from 'src/models/Objednavka';
import moment from 'moment'
import TurnusStore from 'src/stores/TurnusStore';
import KlientStore from 'src/stores/KlientStore';
import Turnus from 'src/models/Turnus';
import Klient from 'src/models/Klient';
import { OrderHelper } from 'src/classes/OrderHelper';
import ClientSelectionDialog from './ClientSelectionDialog';
import { DatePicker } from 'material-ui-pickers';
import RozvozStore from 'src/stores/RozvozStore';
import Rozvoz from 'src/models/Rozvoz';
import RozvozPlanGUIElement from 'src/models/RozvozPlanGUIElement';

const styles = createStyles(theme => ({
    dayWrapper: {
        position: "relative",
    },
    day: {
        width: 36,
        height: 36,
        fontSize: theme.typography.caption.fontSize,
        margin: "0 2px",
        color: "inherit",
    },
    customDayHighlight: {
        position: "absolute",
        top: 0,
        bottom: 0,
        left: "2px",
        right: "2px",
        border: `1px solid ${theme.palette.secondary.main}`,
        borderRadius: "50%",
    },
    nonCurrentMonthDay: {
        color: theme.palette.text.disabled,
    },
    highlightNonCurrentMonthDay: {
        color: "#676767",
    },
    highlight: {
        background: theme.palette.primary.main,
        color: theme.palette.common.white,
    },
    firstHighlight: {
        extend: "highlight",
        borderTopLeftRadius: "50%",
        borderBottomLeftRadius: "50%",
    },
    endHighlight: {
        extend: "highlight",
        borderTopRightRadius: "50%",
        borderBottomRightRadius: "50%",
    },
}));

export interface IDeliveryPlanProps extends RouteComponentProps<any> {
    objednavkaStore?: ObjednavkaStore;
    turnusStore?: TurnusStore;
    klientStore?: KlientStore;
    rozvozStore?: RozvozStore;
    classes;
}

@inject('objednavkaStore')
@inject('turnusStore')
@inject('klientStore')
@inject('rozvozStore')

@observer
class DeliveryPlan extends React.Component<IDeliveryPlanProps>{

    @observable private isDrawerOpened: boolean = false;

    @observable private delivaryPlanDate: Date = new Date();

    @observable private klienti: Klient[] = [];

    @observable private guiModel: Map<number, RozvozPlanGUIElement> = new Map();

    @observable private rozvozy: Map<number, Rozvoz[]> = new Map();

    @action
    private drawerMenuClick = event => {
        this.isDrawerOpened = !this.isDrawerOpened;
    }

    @action
    private handleReportDateChange = date => {
        this.delivaryPlanDate = date;
        this.klienti = [];
        this.guiModel.clear();
        this.props.rozvozStore.loadByDate(moment(date).startOf('week').toDate())
            .then(result => {
                const klientiTemp: Klient[] = [];
                this.props.rozvozStore.rozvozy.forEach(rozvoz => {
                    if(!this.guiModel.has(rozvoz.idKlient)) {
                        this.rozvozy.set(rozvoz.idKlient, []);
                        const klient = this.props.klientStore.getClientById(rozvoz.idKlient);
                        this.guiModel.set(rozvoz.idKlient, new RozvozPlanGUIElement(klient, rozvoz.poradi));
                        klientiTemp.push(klient);
                    }
                    const weekDay = moment(rozvoz.datum).isoWeekday();
                    console.log('weekday: ' + weekDay + ' klient: ' + rozvoz.idKlient);
                    this.guiModel.get(rozvoz.idKlient).daysActive[weekDay-1] = true;
                    if(rozvoz.stridavyRozvoz === 'resit') {
                        this.guiModel.get(rozvoz.idKlient).daysStridave[weekDay-1] = true;
                    }
                    this.rozvozy.get(rozvoz.idKlient).push(rozvoz);
                });
                this.klienti = klientiTemp;
            });
    }

    private formatWeekSelectLabel = (date, invalidLabel) => {
        return "Týden od " + moment(date).startOf('week').format('Do MMM');
    }

    private renderWeek = (date, selectedDate, dayInCurrentMonth) => {
        const dateOrig = moment(date);
        const selectedDateOrig = moment(selectedDate);

        const startOfWeekDate = moment(selectedDate).startOf('week');
        const endOfWeekDate = moment(selectedDate).endOf('week');

        const start = dateOrig.isSame(startOfWeekDate, 'day');
        const end = dateOrig.isSame(endOfWeekDate, 'day');
        const between = dateOrig.isBetween(startOfWeekDate, endOfWeekDate);

        const classes = [];
        const classesDay = [this.props.classes.day];

        if(start) {
            classes.push(this.props.classes.firstHighlight);
        }

        if(end) {
            classes.push(this.props.classes.endHighlight);
        }

        if(between || start) {
            classes.push(this.props.classes.highlight);
        }

        if(!dayInCurrentMonth) {
            classesDay.push(this.props.classes.nonCurrentMonthDay);
        }

        let classesString:string = '';
        let classesDayString:string = '';

        classes.forEach(element => {
            classesString += element + ' ';
        });

        classesDay.forEach(element => {
            classesDayString += element + ' ';
        });

        return (
            <div className={classesString}>
                <IconButton className={classesDayString}>
                    <span> {dateOrig.format("D")} </span>
                </IconButton>
            </div>
        );
    }

    private stridaveCheckBoxValueChanged = (model: RozvozPlanGUIElement, day: number) => event => {
        model.daysStridaveActive[day] = !model.daysStridaveActive[day];
    }

    private getDayCheckBox = (model: RozvozPlanGUIElement, day: number) => {
        if(model.daysActive[day]) {
            return (
                <Checkbox 
                    value={!model.daysStridaveActive[day]} 
                    disabled={!model.daysStridave[day]}
                    onChange={this.stridaveCheckBoxValueChanged(model, day)} />
            );
        } else {
            return "";
        }
    }

    public render() {
        return (
            <div>
                <Drawer open={this.isDrawerOpened} onClose={this.drawerMenuClick}>
                    <NavigationDrawerItems />
                </Drawer>

                <Grid container spacing={8}>
                    <Grid item xs={12}>
                        <AppBar position="static" >
                            <Toolbar>
                                <IconButton color="inherit" aria-label="Menu" onClick={this.drawerMenuClick}>
                                    <MenuIcon />
                                </IconButton>
                                <Typography variant="h6" color="inherit"  style={{ flexGrow: 1 }}>
                                    Rozvovový plán
                                </Typography>
                            </Toolbar>
                        </AppBar>
                    </Grid>
                    <Grid item xs={12} style={{ margin: 8 }}>
                        <Paper>
                            <Grid container spacing={8}>
                                <Grid item xs={12} style={{ margin: 8 }}>
                                    <DatePicker 
                                        label="Datum reportu" 
                                        value={this.delivaryPlanDate} 
                                        onChange={this.handleReportDateChange}
                                        renderDay={this.renderWeek}
                                        labelFunc={this.formatWeekSelectLabel} />
                                </Grid>
                                <Grid item xs={12} style={{ margin: 8 }}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Klient</TableCell>
                                                <TableCell>Po</TableCell>
                                                <TableCell>Út</TableCell>
                                                <TableCell>St</TableCell>
                                                <TableCell>Čt</TableCell>
                                                <TableCell>Pá</TableCell>
                                                <TableCell>Adresa</TableCell>
                                                <TableCell>Náhradní adresa</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                        {this.klienti.map(item => {
                                            const guiModelItem: RozvozPlanGUIElement = this.guiModel.get(item.id);
                                            return (
                                            <TableRow key="test">
                                                <TableCell>{item.getFullName()}</TableCell>
                                                <TableCell>{this.getDayCheckBox(guiModelItem, 0)}</TableCell>
                                                <TableCell>{this.getDayCheckBox(guiModelItem, 1)}</TableCell>
                                                <TableCell>{this.getDayCheckBox(guiModelItem, 2)}</TableCell>
                                                <TableCell>{this.getDayCheckBox(guiModelItem, 3)}</TableCell>
                                                <TableCell>{this.getDayCheckBox(guiModelItem, 4)}</TableCell>
                                                <TableCell>{item.getFullAddress()}</TableCell>
                                                <TableCell>{item.nahradniAdresa}</TableCell>
                                            </TableRow>
                                        )})}
                                        </TableBody>
                                    </Table>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

export default  withRouter(withStyles(styles)(DeliveryPlan));


// WEBPACK FOOTER //
// ./src/components/DeliveryPlan.tsx